/* eslint-disable jira/choreographer/message-id-by-folder-structure */
// ported from jira/src/packages/issue/issue-view-common-views/src/web-link-line-card-group/delete-modal/index.tsx
import React, { type SyntheticEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button/new';
import { ModalHeader, ModalTitle, ModalBody, ModalFooter } from '@atlaskit/modal-dialog';
import { JiraModal as ModalDialog } from '@atlassian/jira-modal/src/ui/jira-modal.tsx';
import ShortcutScope from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcut-scope.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

interface Props {
	onConfirm: (_: SyntheticEvent, analyticsEvent: UIAnalyticsEvent) => void;
	onCancel: (_: SyntheticEvent | KeyboardEvent, analyticsEvent: UIAnalyticsEvent) => void;
}

export const DeleteModal = ({ onConfirm, onCancel }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const headerMessage = formatMessage(messages.headerMessage);
	const contentMessage = formatMessage(
		fg('jira-issue-terminology-refresh-m3')
			? messages.contentMessageIssueTermRefresh
			: messages.contentMessage,
	);
	const confirmActionText = formatMessage(messages.confirmActionText);
	const cancelActionText = formatMessage(messages.cancelActionText);

	return (
		<>
			<ShortcutScope>
				<ModalDialog
					messageId="issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.delete-modal.modal-dialog"
					messageType="transactional"
					onClose={onCancel}
					width="small"
				>
					<ModalHeader hasCloseButton={fg('issue-view-enghealth-40720-modal-close-button')}>
						<ModalTitle appearance="danger">{headerMessage}</ModalTitle>
					</ModalHeader>
					<ModalBody>{contentMessage}</ModalBody>

					<ModalFooter>
						<Button appearance="primary" onClick={onConfirm}>
							{confirmActionText}
						</Button>
						<Button appearance="subtle" onClick={onCancel}>
							{cancelActionText}
						</Button>
					</ModalFooter>
				</ModalDialog>
			</ShortcutScope>
		</>
	);
};

export default DeleteModal;
